_ = require('underscore');
module.exports = {
    "fullscreen": function(obj) {
var __t, __p = '';
__p += '\n    <div class="mobile-ad-fullscreen-close-container">\n        ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n    </div>\n    <div class="mobile-ad-fullscreen-subcontainer">\n        <div class="mobile-ad-fullscreen-header">\n            ' +
((__t = ( obj.logoIcon )) == null ? '' : __t) +
'\n            <p class="mobile-ad-fullscreen-header-copy">Browse Faster in the App</p>\n        </div>\n        <div class="mobile-ad-fullscreen-content">\n            <div class="mobile-ad-fullscreen-button">\n                <a href="#" class="mobile-ad-fullscreen-deep-link-link">Continue in App</a>\n            </div>\n        </div>\n    </div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/templates/global/mobileAds/mobile-ad-fullscreen.html
// module id = 3906
// module chunks = 63